import { Pipe, PipeTransform } from '@angular/core';
import {INotification} from '../../../objects/INotification';

@Pipe({
  name: 'getOnlyNew'
})
export class GetOnlyNewPipe implements PipeTransform {

  transform(notifications: INotification[], isNew = true, maxNotifications = 0, ...args: unknown[]): INotification[] {
    const array = notifications.filter(e => e.read === ((isNew) ? '0' : '1'));
    if (maxNotifications !== 0) {
      return array.slice(0, maxNotifications);
    }
    return array;
  }

}
